import { Component, computed, signal } from "@angular/core";

import { LiquidElementPdf, LiquidPdf } from "../../../liquid-page.models";

@Component({
    selector: 'meta-liquid-pdf',
    templateUrl: './liquid-pdf.component.html',
    styleUrls: ['./liquid-pdf.component.css'],
})
export class LiquidPdfComponent {
    $input = signal<LiquidElementPdf | undefined>(undefined);
    $output = computed<LiquidPdf>(() => {
        if (this.$input()) {
            return { src: this.$input()?.value };
        }

        return { src: undefined };
    })
}